export default {
    GA_TRACKER_LOADED: 'GA_TRACKER_LOADED'
};


// WEBPACK FOOTER //
// ./src/utils/eventKeys.js